// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d202aafd","453":"d29c3f0a","732":"0b5985dc"}[chunkId] + ".chunk.js";
};